import React from 'react'
import './cta.css'

const CTA = () => {
  return (
    <div className='gpt3__cta'>
      <div className="gpt3__cta_container">
        <div className='gpt3__cta-text'>
          <p>Request Early Access to Get Started</p>
          <h3>Register today & start exploring the endless possiblities.</h3>
        </div>
        <div className='gpt3__cta-button'><button>Get Started</button></div>
      </div>    
    </div>
  )
}

export default CTA